/* istanbul ignore file */
import { useAuth } from '@dhxete/auth-provider'
import Modal from '@dhxete/modal'
import Paragraph from '@dhxete/paragraph'
import 'core-js/stable'
import React, { useEffect, useReducer } from 'react'
import 'regenerator-runtime/runtime'
import pages from '../pages';
import reducer from '../reducer';
import {
  aknLangSelected,
  availableLangList,
  chatDetails,
  initState,
} from './App.config'

const App = () => {
  const auth = useAuth()
  const [state, dispatch] = useReducer(reducer, initState)
  const props = { auth, state, dispatch }
  const curPage = pages[state.curPage]

  useEffect(() => {
    // Set up language
    if (availableLangList.includes(aknLangSelected)) {
      dispatch({
        type: 'SET_UP_LANGUAGE_STRINGS',
        payload: aknLangSelected,
      })
    }
  }, [])

  useEffect(() => {
    ;(async () => {
      if (!auth.isLoading) {
        if (auth.isAuthenticated) {
          // Populate router credentials and requester info from auth data
          dispatch({
            type: 'USER_AUTHENTICATED',
            payload: {
              token: auth.token,
              user: auth.user,
            },
          })
        }
        // Begin CM Process
        dispatch({ type: 'GO_TO_WELCOME_PAGE' })
      }
    })()
  }, [auth])

  const modalProps = {
    ...props,
    title:
      state.curPage === 'createCasePage' ||
      state.curPage === 'createCaseSuccessPage'
        ? state.langStrings.contactOptions.createCase
        : state.curPage === 'agentAvailable'
        ? state.langStrings.contactOptions.chatWithAgent
        : state.langStrings.cm.welcome.modalTitle,
  }

  const footerProps = {
    ...props,
    chatDetails,
    chatSubject: `Chat- ${state.langStrings.cm.welcome.modalTitle}`,
    chatDescription: `Contract number: ${state.currentCMDetails.contractNumber}\n Current contract manager’s email: ${state.currentCMDetails.authEmail}\n New contract manager’s email: ${state.newCmDetails.email}\n New contract manager’s name: ${state.newCmDetails.firstName} ${state.newCmDetails.lastName}\n New contract manager’s phone number: ${state.newCmDetails.phone}`,
  }

  let footerProperties = {
    ...footerProps,
    state: { ...props.state },
  }
  if (curPage.configFooter) {
    const footerPropsUpate = curPage.configFooter(props)
    footerProperties = { ...footerProperties, ...footerPropsUpate }
  }
  return (
    <Modal {...modalProps} mode="page" footerProps={footerProperties}>
      {curPage.configContents(props).map((item, i) => (
        <Paragraph {...props} key={i} {...item} />
      ))}
    </Modal>
  )
}

export default App;
